module.exports = __webpack_public_path__ + "img/gallery_hero_2.cad09bc5.jpg";